/**
 * Returns true if the step has saved puck content (non-empty content array).
 * Used to route PROMO steps through PuckStep when the author has added
 * puck blocks (text, OffersSection, etc.) via the Puck editor — beaker2 does
 * not change the step type on edit, so the type stays PROMO but the puck
 * data lives in step.content.
 */
export function stepHasPuckContent(step) {
  try {
    // beaker2-utils enriches PROMO steps by calling GET /step/:stepId and
    // storing the result as step[type.toLowerCase()] — so for PROMO the
    // puck data lands on step.promo, not step.content / step.puck.
    if (Array.isArray(step.promo?.content) && step.promo.content.length > 0) {
      return true
    }
    // PUCK steps: beaker2 enrichment puts the parsed puck object on step.puck.
    if (step.puck) {
      const parsed = typeof step.puck === 'string' ? JSON.parse(step.puck) : step.puck
      return Array.isArray(parsed?.content) && parsed.content.length > 0
    }
    return false
  } catch {
    return false
  }
}

/**
 * Returns true if the puck data for a step contains a component with a
 * non-empty `startScreen` slot (e.g. a PollStartScreen block), meaning the
 * puck content manages its own start screen and the outer StartSlideWrapper
 * should be suppressed.
 */
export function puckHasOwnStartScreen(step) {
  try {
    const raw = step.puck ?? step.content
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    if (!parsed?.content || !Array.isArray(parsed.content)) return false
    return parsed.content.some(
      item =>
        Array.isArray(item?.props?.startScreen) &&
        item.props.startScreen.length > 0,
    )
  } catch {
    return false
  }
}
